import React, {useEffect, useState} from 'react';
import {
  Collapse,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import {
  AddCircle,
  DesignServices,
  ExpandLess,
  ExpandMore,
  ExploreOutlined,
  // HomeOutlined,
  HomeWorkOutlined,
  PageviewOutlined,
  // WorkOutlineOutlined,
} from '@mui/icons-material';
import {useListStyles} from './MenuStyles';
import {ItemsCommon} from './ItemsCommon';
import {NavigationPath} from '../SelectedIndexUtil';
import Anchor from '../../../../common/Anchor';

interface IProps {
  width: number;
  selectedIndex: NavigationPath;
  handleListItemClick: (navigationPath: NavigationPath) => void;
  handleClickCreateProject: () => void;
}

export const ItemsAnonymous: React.FC<IProps> = (props) => {
  const classes = useListStyles(props.width)();
  const [getItDoneOpen, setGetItDoneOpen] = useState(true);
  const {selectedIndex, handleListItemClick} = props;
  // const isMobileLayout = props.width < 601;

  useEffect(() => {
    [
      NavigationPath.MY_RFPS,
      NavigationPath.COMMUNITY_RFPS,
      NavigationPath.CONTRACTOR_SEARCH,
      NavigationPath.RESOURCES,
      NavigationPath.DESIGNMII,
    ].includes(selectedIndex) && setGetItDoneOpen(true);
  }, [selectedIndex]);

  return (
    <List className={classes.listRoot}>
      <ListItem
        button
        disableGutters
        key="getItDone"
        onClick={() => setGetItDoneOpen(!getItDoneOpen)}
        classes={{
          root: classes.drawerItemHeading,
          selected: classes.drawerItemSelected,
        }}>
        <ListItemText
          primaryTypographyProps={{variant: 'subtitle2'}}
          primary="GET IT DONE"
        />
        {getItDoneOpen ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={getItDoneOpen} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItem
            button
            disableGutters
            key="postAProject"
            onClick={props.handleClickCreateProject}
            className={classes.drawerItemRoot}>
            <ListItemIcon>
              <AddCircle />
            </ListItemIcon>
            <ListItemText
              primaryTypographyProps={{variant: 'subtitle2'}}
              primary="POST A PROJECT"
            />
          </ListItem>
          <Anchor href={NavigationPath.DESIGNMII}>
            <ListItem
              button
              key={NavigationPath.DESIGNMII}
              selected={selectedIndex === NavigationPath.DESIGNMII}
              onClick={() => handleListItemClick(NavigationPath.DESIGNMII)}
              classes={{
                root: classes.drawerItemRoot,
                selected: classes.drawerItemSelected,
              }}>
              <ListItemIcon>
                <DesignServices />
              </ListItemIcon>
              <ListItemText
                primaryTypographyProps={{variant: 'subtitle2'}}
                primary="DESIGNMII"
              />
            </ListItem>
          </Anchor>
          <Anchor href={NavigationPath.COMMUNITY_RFPS}>
            <ListItem
              button
              key={NavigationPath.COMMUNITY_RFPS}
              selected={selectedIndex === NavigationPath.COMMUNITY_RFPS}
              onClick={() => handleListItemClick(NavigationPath.COMMUNITY_RFPS)}
              classes={{
                root: classes.drawerItemRoot,
                selected: classes.drawerItemSelected,
              }}>
              <ListItemIcon>
                <HomeWorkOutlined />
              </ListItemIcon>
              <ListItemText
                primaryTypographyProps={{variant: 'subtitle2'}}
                primary="COMMUNITY PROJECTS"
              />
            </ListItem>
          </Anchor>
          {/* <Anchor href={NavigationPath.MY_RFPS}>
            <ListItem
              button
              key={NavigationPath.MY_RFPS}
              selected={selectedIndex === NavigationPath.MY_RFPS}
              onClick={() => handleListItemClick(NavigationPath.MY_RFPS)}
              classes={{
                root: classes.drawerItemRoot,
                selected: classes.drawerItemSelected,
              }}>
              {isMobileLayout && (
              <ListItemIcon>
                <HomeOutlined />
              </ListItemIcon>
              )}
              <ListItemText
                primaryTypographyProps={{variant: 'subtitle2'}}
                primary="MY PROJECTS"
              />
            </ListItem>
          </Anchor> */}
          {/* <Anchor href={NavigationPath.RFPS}>
            <ListItem
              button
              key={NavigationPath.RFPS}
              selected={selectedIndex === NavigationPath.RFPS}
              onClick={() => handleListItemClick(NavigationPath.RFPS)}
              classes={{
                root: classes.drawerItemRoot,
                selected: classes.drawerItemSelected,
              }}>
              {isMobileLayout && (
                <ListItemIcon>
                  <WorkOutlineOutlined />
                </ListItemIcon>
              )}
              <ListItemText
                primaryTypographyProps={{variant: 'subtitle2'}}
                primary="AVAILABLE JOBS"
              />
            </ListItem>
          </Anchor> */}
          <Anchor href={NavigationPath.CONTRACTOR_SEARCH}>
            <ListItem
              button
              key={NavigationPath.CONTRACTOR_SEARCH}
              selected={selectedIndex === NavigationPath.CONTRACTOR_SEARCH}
              onClick={() =>
                handleListItemClick(NavigationPath.CONTRACTOR_SEARCH)
              }
              classes={{
                root: classes.drawerItemRoot,
                selected: classes.drawerItemSelected,
              }}>
              <ListItemIcon>
                <PageviewOutlined />
              </ListItemIcon>
              <ListItemText
                primaryTypographyProps={{variant: 'subtitle2'}}
                primary="FIND A CONTRACTOR"
              />
            </ListItem>
          </Anchor>
          <Anchor href={NavigationPath.RESOURCES}>
            <ListItem
              button
              key={NavigationPath.RESOURCES}
              selected={selectedIndex === NavigationPath.RESOURCES}
              onClick={() => handleListItemClick(NavigationPath.RESOURCES)}
              classes={{
                root: classes.drawerItemRoot,
                selected: classes.drawerItemSelected,
              }}>
              <ListItemIcon>
                <ExploreOutlined />
              </ListItemIcon>
              <ListItemText
                primaryTypographyProps={{variant: 'subtitle2'}}
                primary="RESOURCES"
              />
            </ListItem>
          </Anchor>
        </List>
      </Collapse>
      <Divider style={{margin: '4px 0'}} />
      <ItemsCommon
        width={props.width}
        isLoggedIn={false}
        selectedIndex={selectedIndex}
        handleListItemClick={handleListItemClick}
        handleLogoutClick={() => {}}
      />
    </List>
  );
};
